import { gql } from '@apollo/client';

export const ACCOUNT_CONTEXT_QUERY = gql(`
  query GetAccountContext {
    currentAdvertiser {
      ... on CurrentAdvertiserContext {
        __typename
        name
        billingId
        advertiserId
        seekId
      }
      ... on MissingAdvertiserIdClaimError {
        __typename
        message
      }
    }
    headerFooterContext {
      identityContext {
        email
        act {
          operatorEmail
          csToggleText
          isCsView
        }
      }
      user {
        name
        firstName
        id
      }
      advertiser {
        name
        billingId
        hasMultipleAccounts
        permissionOptions {
          canCreateJobs
          canManageBrand
          canManageCompanyProfile
          canManageUsers
          canPayInvoices
          canViewInsightsRoleReport
          canViewInvoiceHistory
          canViewManagerReports
        }
        showOnCreditHoldMessage
        isActivationPending
        switchAccountsHref
        isAgency
      }
    }
  }
`);

export const USER_LIST_QUERY = gql(`
  query GetUserList {
    usersList: hirerAccount(
      usersParams: {
        usersFilter: [ACTIVE, PENDING, UNVERIFIED]
        include: ACCESS_DETAILS
        accessRightFilter: [ACTIVE, PENDING, USER_ROLE, ADMIN_ROLE]
      }
    ) {
      users {
        id
        email
        firstName
        lastName
        status
        permissions {
          canCreatePosition
          hasAllPositionAccess
          hasAnalytics
          hasPremiumTalentSearch
          role
        }
      }
    }
    adminsList: hirerAccount(
      usersParams: {
        usersFilter: [ACTIVE, PENDING, UNVERIFIED]
        accessRightFilter: [ACTIVE, PENDING, ADMIN_ROLE]
        include: ACCESS_DETAILS
      }
    ) {
      users {
        id
        permissions {
          role
        }
      }
    }
  }
`);

export const LOGGED_IN_USER_DETAILS_QUERY = gql(`
  query GetLoggedInUser {
    currentUser {
      ... on CurrentUserContext {
        id
        firstName
        lastName
        email
      }
    }
    currentAdvertiser {
      ... on CurrentAdvertiserContext {
        role
        advertiserId
      }
    }
  }
`);

export const HIRER_USER_EMAIL_QUERY = gql(`
  query HirerUserEmailV2($input: HirerUserEmailInputV2!) {
    hirerUserEmailV2(input: $input) {
      ... on HirerUserEmailFoundPayloadV2 {
        email
        hirerUserId
        status
        __typename
      }
      ... on HirerUserEmailNotFoundPayloadV2 {
        message
        __typename
      }
      ... on ResponseError {
        error
        __typename
      }
    }
  }
`);

export const HIRER_USER_QUERY = gql(`
  query HirerUser($input: HirerUserQueryInput!) {
    hirerUser(input: $input) {
      hirerUserId
      email
      givenName
      familyName
      status
      permissions {
        hasPremiumTalentSearch
        hasAllPositionAccess
        hasAnalytics
        canCreatePosition
        role
      }
    }
  }
`);

export const TALENT_SEARCH_CONTEXT_QUERY = gql(`
  query GetTalentSearchUserContext($input: TalentSearchUserContextInput!) {
    talentSearchUserContextV2(input: $input) {
      claims
    }
  }
`);
